var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SideBar',{attrs:{"title":"En Construcción..."}},[_c('div',{attrs:{"id":"blank_parent"},domProps:{"innerHTML":_vm._s(require("!html-loader!../../assets/illustrations/en_construccion_trabajador.svg"))}})])}
var staticRenderFns = []

export { render, staticRenderFns }